import "./App.css";
import SmoothScroll from "smooth-scroll";
import { Home } from "./components/home";
import { About } from "./components/about/about";
import { LayoutTop } from "./components/layoutTop";
import { LayoutBottom } from "./components/layoutBottom";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ServiceView } from "./components/serviceView/serviceView";
import { Products } from "./components/products/products";
import { Services } from "./components/services";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  return (
    <BrowserRouter>
      <LayoutTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us/" element={<About />} />
        <Route path="/products/" element={<Products />} />
        <Route path="/services/" element={<Services />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <LayoutBottom />
    </BrowserRouter>
  );
};

export default App;
